<template>
  <div class="leco-content">
    <transition appear mode="out-in">
      <div class="auth-page">
        <div class="container mt-4 mb-5">
          <div class="row">
            <!-------------------------------------------------------------------------------------------->
            <div
              v-if="passChangeStatus == 'Init'"
              class="col-md-6 offset-md-3 col-xs-12"
            >
              <h2 class="text-center mb-4">パスワードの変更</h2>
              <div v-if="errorMessages.length > 0" class="alert alert-danger">
                <ul>
                  <li v-for="msg in errorMessages" :key="msg">{{ msg }}</li>
                </ul>
              </div>
              <form @submit.prevent="forgotPassword">
                <p>
                  ご自身のメールアドレスを入力してください。<br />
                  指定されたメールアドレスにパスワード変更用のコードを送信します。
                </p>
                <fieldset class="form-group">
                  <input
                    class="form-control form-control-lg"
                    type="text"
                    v-model="email"
                    placeholder="email"
                  />
                </fieldset>
                <button
                  class="btn btn-lg btn-outline-secondary float-right btn-execute"
                >
                  コードを送信
                </button>
              </form>
            </div>
            <!-------------------------------------------------------------------------------------------->
            <div
              v-else-if="passChangeStatus == 'ResetCodeInput'"
              class="col-md-6 offset-md-3 col-xs-12"
            >
              <h2 class="text-center mb-4">リセットコードを送信しました</h2>
              <div v-if="errorMessages.length > 0" class="alert alert-danger">
                <ul>
                  <li v-for="msg in errorMessages" :key="msg">{{ msg }}</li>
                </ul>
              </div>
              <p>
                メールでリセットコードを確認してください。新しいコードをリクエストする場合、前の手順に戻って変更の手続きを進めてください。
              </p>
              <form @submit.prevent="saveResetCode">
                <fieldset class="form-group">
                  <input
                    class="form-control form-control-lg"
                    type="text"
                    v-model="resetCode"
                    placeholder="リセットコード"
                  />
                </fieldset>

                <button
                  class="btn btn-lg btn-outline-secondary float-right btn-execute"
                >
                  次へ
                </button>
              </form>
            </div>
            <!-------------------------------------------------------------------------------------------->
            <div
              v-else-if="passChangeStatus == 'PasswordInput'"
              class="col-md-6 offset-md-3 col-xs-12"
            >
              <h2 class="text-center mb-4">新しいパスワードの設定</h2>
              <div v-if="errorMessages.length > 0" class="alert alert-danger">
                <ul>
                  <li v-for="msg in errorMessages" :key="msg">{{ msg }}</li>
                </ul>
              </div>
              <p>新しいパスワードを設定してください。</p>
              <h6 class="text-left">
                ※他のWebサービスで利用していないパスワードを設定してください。<br />
                &nbsp;&nbsp;（10文字以上、英数、大文字、小文字、特殊文字を全て含む）
              </h6>
              <h6 class="text-left mb-4">
                ※利用できる特殊文字『{{ usable_kigou }}』
              </h6>
              <form @submit.prevent="changePassword">
                <input
                  class="form-control form-control-lg dummyPass"
                  type="password"
                />

                <fieldset class="form-group">
                  <input
                    class="form-control form-control-lg"
                    type="password"
                    v-model="password"
                    placeholder="New Password"
                  />
                </fieldset>
                <fieldset class="form-group">
                  <input
                    class="form-control form-control-lg"
                    type="password"
                    v-model="passwordConfirm"
                    placeholder="New Password again"
                  />
                </fieldset>
                <button
                  class="btn btn-lg btn-outline-secondary float-right btn-execute"
                >
                  パスワードを変更
                </button>
              </form>
            </div>
            <!-------------------------------------------------------------------------------------------->
            <div
              v-else-if="passChangeStatus == 'PasswordChangeComplete'"
              class="col-md-6 offset-md-3 col-xs-12"
            >
              <h2 class="text-center mb-4">完了しました</h2>
              <div v-if="errorMessages.length > 0" class="alert alert-danger">
                <ul>
                  <li v-for="msg in errorMessages" :key="msg">{{ msg }}</li>
                </ul>
              </div>
              <p>パスワードを変更しました。</p>
              <form @submit.prevent="gotoLogin">
                <button
                  class="btn btn-lg btn-outline-secondary float-right btn-execute"
                >
                  ログインページへ
                </button>
              </form>
            </div>
          </div>
          <loading :active.sync="isPostLoading"></loading>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { PURGE_ERROR } from "@/store/mutations.type";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "password-reset",
  data() {
    return {
      passChangeStatus: "Init",
      email: "",
      resetCode: "",
      password: "",
      passwordConfirm: "",
      errorMessages: [],
      isPostLoading: false,
      logger: this.$store.state.logger,
      usable_kigou:
        "^ $ * . [ ] { } ( ) ? \" ! @ # % & / \\ , > < ' : ; | _ ~ `"
    };
  },
  components: {
    loading: Loading
  },
  methods: {
    forgotPassword() {
      this.errorMessages = [];

      // 必須入力チェック
      if (this.email == "") {
        this.errorMessages.push("Eメールは必須項目です。");
        return;
      }

      // ローディングアイコン表示
      this.isPostLoading = true;

      // Cognitoパスワードリセットキー発行API実行
      this.$cognito
        .forgotPassword(this.email)
        .then((result) => {
          this.logger.debug("forgotPassword success:" + JSON.stringify(result));
          this.isPostLoading = false;
          this.passChangeStatus = "ResetCodeInput";
        })
        .catch((err) => {
          // エラーなのでローディング非表示にする
          this.isPostLoading = false;
          if (err.code == "NotAuthorizedException") {
            this.errorMessages.push(
              "ユーザー名またはパスワードが誤っています。"
            );
            return;
          } else if (err.code == "LimitExceededException") {
            this.errorMessages.push(
              "パスワード再設定回数の上限に達しました。間隔をあけて再度お試しください。"
            );
            return;
          } else {
            this.logger.error(JSON.stringify(err));
            this.errorMessages.push("認証エラー。" + err.message);
            return;
          }
        });
    },
    saveResetCode() {
      this.errorMessages = [];

      // 必須入力チェック
      if (this.resetCode == "") {
        this.errorMessages.push("リセットコードは必須項目です。");
        return;
      }

      // 確認コードのフォーマットチェック
      let re = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
      if (!re.test(this.resetCode) || this.resetCode.length != 6) {
        this.errorMessages.push("確認コードのフォーマットが正しくありません。");
        return;
      }
      this.passChangeStatus = "PasswordInput";
    },
    changePassword() {
      this.errorMessages = [];

      // パスワード一致チェック
      if (this.password != this.passwordConfirm) {
        this.errorMessages.push("パスワードが一致していません。");
        return;
      }

      // ローディングアイコン表示
      this.isPostLoading = true;

      // パスワード再設定API実行
      this.$store.commit(PURGE_ERROR);
      this.$cognito
        .forgotPasswordSubmit(this.email, this.resetCode, this.password)
        .then((result) => {
          this.logger.debug(
            "cognito forgotPasswordSubmit successed:" + JSON.stringify(result)
          );
          this.isPostLoading = false;
          this.passChangeStatus = "PasswordChangeComplete";
        })
        .catch((err) => {
          // エラーなのでローディング非表示にする
          this.isPostLoading = false;
          if (err.code == "ExpiredCodeException") {
            this.errorMessages.push(
              "URLの使用期限が過ぎているか、使用済のURLが使用された可能性があります。\n" +
                "再度パスワード変更を行ってください。"
            );
            return;
          } else if (
            err.code == "InvalidPasswordException" ||
            err.code == "InvalidParameterException"
          ) {
            this.errorMessages.push(
              "パスワードは以下を含むように設定してください。"
            );
            this.errorMessages.push("10文字以上");
            this.errorMessages.push("英字・数字を含む");
            this.errorMessages.push("大文字・小文字を含む");
            this.errorMessages.push("特殊文字（,.!@()'\"など）を含む");
            return;
          } else {
            this.logger.error(JSON.stringify(err));
            this.errorMessages.push("パスワード設定エラー。" + err.message);
            return;
          }
        });
    },
    gotoLogin() {
      this.$router.replace("/login");
    }
  }
};
</script>

<style scoped>
.auth-page {
  flex: 1;
}

.btn-execute {
  width: 200px;
}

.dummyPass {
  position: absolute;
  left: -200vh;
}
</style>
